export default {
  state: {
    token: localStorage.getItem('token') || '',
    refreshToken: localStorage.getItem('refreshToken') || '',
    status: '',
    rememberMe: localStorage.getItem('rememberMe') || false
  },

  mutations: {
    SET_STATUS(state, payload) {
      state.status = payload
    },
    SET_TOKEN(state, payload) {
      state.token = payload
    },
    SET_REFRESHTOKEN(state, payload) {
      state.refreshToken = payload
    },
    SET_REMEMBERME_STATUS(state, payload) {
      state.rememberMe = payload
    }
  },

  actions: {
    setStatus({commit}, payload) {
      commit('SET_STATUS', payload)
    },

    // LOGIN
    async logIn({ commit, dispatch }, payload) {
      dispatch('updateLoading', true)
      commit('SET_TOKEN', payload.access)
      localStorage.setItem('token', payload.access)

      commit('SET_REFRESHTOKEN', payload.refresh)
      localStorage.setItem('refreshToken', payload.refresh)
      if (payload.rememberMe) {
        commit('SET_REMEMBERME_STATUS', payload.rememberMe)
        localStorage.setItem('rememberMe', payload.rememberMe)
      }
      dispatch('updateLoading', false)
      dispatch('updateUserInfo')
    },

    // LOGOUT
    async logOut({ commit, dispatch }) {
      dispatch('updateLoading', true)

      localStorage.removeItem('token')
      commit('SET_TOKEN', '')

      localStorage.removeItem('refreshToken')
      commit('SET_REFRESHTOKEN', '')

      localStorage.removeItem('rememberMe')
      commit('SET_REMEMBERME_STATUS', false)

      dispatch('updateLoading', false)
    },

    // UPDATE_TOKEN
    updateToken({ commit }, payload) {
      commit('SET_TOKEN', payload)
    }
  },

  getters: {
    isLoggedIn: state => !!state.token,
    status: state => state.status,
    rememberMe: state => state.rememberMe
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js